import { NodeView } from 'prosemirror-view'
import Styles from './AIRevision.module.scss'
import { Node } from 'prosemirror-model'

export class AIRevision implements NodeView {
  dom: HTMLSpanElement
  contentDOM: HTMLElement

  constructor(node: Node) {
    this.contentDOM = this.dom = document.createElement('span')
    this.dom.className = Styles.aiRevision
    this.dom.dataset.revisionUuid = node.attrs.uuid
  }
}
